import { NgModule } from '@angular/core';

import { Navfill } from './Navfill.component';

@NgModule({
  declarations: [Navfill],
  exports: [Navfill],
})
export class NavfillModule {}
